import React from 'react'
import { withRouter } from 'react-router';
import { Modal } from 'react-bootstrap';
import { PageStatus } from '../../enums';
import { Show } from 'Layout';
import { AuthAPI } from '../../API';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';


class ForgetPasswordEmail extends React.Component {

  constructor(props) {
    super(props);
    (this.state = {
      error: null,
      status: PageStatus.None,
      email: '',
      showError: false,
      showSuccess: false,
    })

  }


  SendResetPasswordLink() {
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Submitting }))
      .then(() => AuthAPI.ResetPasswordLink(this.state.email, this.props.language))
      .then((res) => {
        if (res === "User with this email does not exists.") {
          alert(this.props.t('auth.forgotPassword.noAccountAlert'));
          this.setState({ showError: true, showSuccess: false })
        } else {
          this.setState({ status: PageStatus.Submitted, email: '', showSuccess: true, showError: false })
        }
      })
      .catch((error) => {
        alert(this.props.t('auth.forgotPassword.invalidEmailAlert'));
        this.setState({ status: PageStatus.Error, error: error.message });
      });

  }

  render() {
    const { t } = this.props;
    return (
      <Modal
        centered
        size='md'
        backdrop='static'
        onHide={this.props.onClose}
        show={this.props.show}
      >
        <form onSubmit={(e) => {
          e.preventDefault();
          this.SendResetPasswordLink();
        }}>
          <Modal.Header closeButton>
            <h4>{t('auth.forgotPasswordTitle')}</h4>
          </Modal.Header>
          <Modal.Body>
            <div className=''>
              <div className='row'>
                <div className='col'>
                  <div className=''>
                    <label htmlFor='email' className='text-dark text-uppercase font-weight-bolder'>
                      {t('auth.emailAddressLabel')}
                    </label>
                    <input
                      name='email'
                      type='email'
                      value={this.state.email}
                      onChange={(e) =>
                        this.setState({ email: e.target.value })
                      }
                      className='form-control'
                      placeholder={t('auth.registeredEmailPlaceholder')}
                      maxLength={200}
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                      required
                    />
                    <Show when={this.state.showError}>
                      <p className="text-danger"> {t('auth.registeredEmailPlaceholder')} </p>
                    </Show>
                    <Show when={this.state.showSuccess}>
                      <p className="text-success">{t('auth.resetLinkSentMessage')} </p>
                    </Show>
                  </div>
                </div>
              </div>
            </div>
            <div >

            </div>

          </Modal.Body>
          <div className="modal-footer">
            <button type="submit" disabled={!this.state.email} className="btn payment-btn-pay">
              {t('auth.sendLinkButton')} </button>
            <button onClick={this.props.onHide} className="btn payment-btn-cls ">{t('common.closeButton')}</button>
          </div>
        </form>
      </Modal>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    isAuth: state.adminUser.adminUser.isAuthenticated,
    token: state.adminUser.adminUser.token,
    language: state.adminUser.adminUser.language,
    isLoading: state.adminUser.adminUser.loading,
    error: state.adminUser.adminUser.error,
  };
};

const ForgetPasswordEmailWithState = withRouter(connect(
  mapStateToProps,
)(withTranslation()(ForgetPasswordEmail)));

ForgetPasswordEmail.propTypes = {
  language: PropTypes.string,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  onHide: PropTypes.func,
};

export {
  ForgetPasswordEmail,
  ForgetPasswordEmailWithState,
};



